import { styled } from 'styled-components';
import { IArticlesLatest1 } from './params';
import { IGlobaVariables } from '../../../components/Layout/styles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IArticlesLatest1;
  $articleBoxVariant: number | string;
}>`
  .articles-latest {
    padding: 50px 0 50px;

    &-header {
      color: ${({ $config: styles }) => styles.group_header.color};
      font-family: ${({ $config: styles }) => styles.group_header.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_header.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_header.fontSize};
      line-height: ${({ $config: styles }) => styles.group_header.lineHeight};
      border-bottom: ${({ $config: styles }) => styles.group_header.borderBottom};
      text-align: ${({ $config: styles }) => styles.group_header.textAlign};
      padding-bottom: ${({ $config: styles }) => (styles.group_header.borderBottom === 'none' ? 0 : '12px')};
      margin-bottom: 30px;
    }

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 30px;
      row-gap: 50px;
    }

    &-category {
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: 12px;

      &-name {
        color: ${({ $config: styles }) => styles.group_category.color};
        font-family: ${({ $config: styles }) => styles.group_category.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_category.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_category.fontSize};
        line-height: ${({ $config: styles }) => styles.group_category.lineHeight};
        text-align: ${({ $config: styles }) => styles.group_category.textAlign};
        font-style: ${({ $config: styles }) => styles.group_category.fontStyle};
        margin-bottom: 0;
      }

      & > div {
        flex: 1;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.sm}) {
    .articles-latest {
      &-list {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}) {
    .articles-latest {
      &-list {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}) {
    .articles-latest {
      &-list {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.xxl}) {
    .articles-latest {
      &-list {
        grid-template-columns: ${({ $articleBoxVariant }) =>
          $articleBoxVariant?.toString() === '5' ? '1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'};
      }
    }
  }
`;

export default Styles;
